import { render, staticRenderFns } from "./AttributeDefinitionsView.vue?vue&type=template&id=57f1fec6&lang=pug&"
import script from "./AttributeDefinitionsView.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports